export const SNAP_RATIOS = {
  small:.6,
  mid: 0.8,
  full: 1,
} as const;
export type SnapKeys = keyof typeof SNAP_RATIOS;
export type SnapSizes =  typeof SNAP_RATIOS[SnapKeys];

export const CLOSE_RATIO = 0.5;
export const FLICK_VELOCITY = 0.5;
